"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _Nutzer = _interopRequireDefault(require("./Nutzer"));
var _RentalItem = _interopRequireDefault(require("./RentalItem"));
var _RentalPackage = _interopRequireDefault(require("./RentalPackage"));
var _StatusEnum = _interopRequireDefault(require("./StatusEnum"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The RentalBooking model module.
 * @module model/RentalBooking
 * @version 0.0.1
 */
class RentalBooking {
  /**
   * Constructs a new <code>RentalBooking</code>.
   * @alias module:model/RentalBooking
   * @param von {Date} 
   * @param bis {Date} 
   * @param adresse {module:model/AdresseBase} 
   * @param veranstaltungsort {String} 
   * @param veranstaltungsthema {String} 
   * @param rechnungsadresse {String} 
   * @param nutzerId {String} 
   * @param id {Number} 
   * @param preis {Number} 
   * @param status {module:model/StatusEnum} 
   */
  constructor(von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse, nutzerId, id, preis, status) {
    RentalBooking.initialize(this, von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse, nutzerId, id, preis, status);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, von, bis, adresse, veranstaltungsort, veranstaltungsthema, rechnungsadresse, nutzerId, id, preis, status) {
    obj['von'] = von;
    obj['bis'] = bis;
    obj['adresse'] = adresse;
    obj['veranstaltungsort'] = veranstaltungsort;
    obj['veranstaltungsthema'] = veranstaltungsthema;
    obj['rechnungsadresse'] = rechnungsadresse;
    obj['nutzer_id'] = nutzerId;
    obj['id'] = id;
    obj['preis'] = preis;
    obj['status'] = status;
  }

  /**
   * Constructs a <code>RentalBooking</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RentalBooking} obj Optional instance to populate.
   * @return {module:model/RentalBooking} The populated <code>RentalBooking</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RentalBooking();
      if (data.hasOwnProperty('archived')) {
        obj['archived'] = _ApiClient.default.convertToType(data['archived'], 'Boolean');
      }
      if (data.hasOwnProperty('von')) {
        obj['von'] = _ApiClient.default.convertToType(data['von'], 'Date');
      }
      if (data.hasOwnProperty('bis')) {
        obj['bis'] = _ApiClient.default.convertToType(data['bis'], 'Date');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('veranstaltungsort')) {
        obj['veranstaltungsort'] = _ApiClient.default.convertToType(data['veranstaltungsort'], 'String');
      }
      if (data.hasOwnProperty('veranstaltungsthema')) {
        obj['veranstaltungsthema'] = _ApiClient.default.convertToType(data['veranstaltungsthema'], 'String');
      }
      if (data.hasOwnProperty('rechnungsadresse')) {
        obj['rechnungsadresse'] = _ApiClient.default.convertToType(data['rechnungsadresse'], 'String');
      }
      if (data.hasOwnProperty('items')) {
        obj['items'] = _ApiClient.default.convertToType(data['items'], [_RentalItem.default]);
      }
      if (data.hasOwnProperty('packages')) {
        obj['packages'] = _ApiClient.default.convertToType(data['packages'], [_RentalPackage.default]);
      }
      if (data.hasOwnProperty('nutzer_id')) {
        obj['nutzer_id'] = _ApiClient.default.convertToType(data['nutzer_id'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('preis')) {
        obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = _StatusEnum.default.constructFromObject(data['status']);
      }
      if (data.hasOwnProperty('nutzer')) {
        obj['nutzer'] = _Nutzer.default.constructFromObject(data['nutzer']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>RentalBooking</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RentalBooking</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of RentalBooking.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // ensure the json data is a string
    if (data['veranstaltungsort'] && !(typeof data['veranstaltungsort'] === 'string' || data['veranstaltungsort'] instanceof String)) {
      throw new Error("Expected the field `veranstaltungsort` to be a primitive type in the JSON string but got " + data['veranstaltungsort']);
    }
    // ensure the json data is a string
    if (data['veranstaltungsthema'] && !(typeof data['veranstaltungsthema'] === 'string' || data['veranstaltungsthema'] instanceof String)) {
      throw new Error("Expected the field `veranstaltungsthema` to be a primitive type in the JSON string but got " + data['veranstaltungsthema']);
    }
    // ensure the json data is a string
    if (data['rechnungsadresse'] && !(typeof data['rechnungsadresse'] === 'string' || data['rechnungsadresse'] instanceof String)) {
      throw new Error("Expected the field `rechnungsadresse` to be a primitive type in the JSON string but got " + data['rechnungsadresse']);
    }
    if (data['items']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['items'])) {
        throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
      }
      // validate the optional field `items` (array)
      for (const item of data['items']) {
        _RentalItem.default.validateJSON(item);
      }
      ;
    }
    if (data['packages']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['packages'])) {
        throw new Error("Expected the field `packages` to be an array in the JSON data but got " + data['packages']);
      }
      // validate the optional field `packages` (array)
      for (const item of data['packages']) {
        _RentalPackage.default.validateJSON(item);
      }
      ;
    }
    // ensure the json data is a string
    if (data['nutzer_id'] && !(typeof data['nutzer_id'] === 'string' || data['nutzer_id'] instanceof String)) {
      throw new Error("Expected the field `nutzer_id` to be a primitive type in the JSON string but got " + data['nutzer_id']);
    }
    // validate the optional field `nutzer`
    if (data['nutzer']) {
      // data not null
      _Nutzer.default.validateJSON(data['nutzer']);
    }
    return true;
  }
}
RentalBooking.RequiredProperties = ["von", "bis", "adresse", "veranstaltungsort", "veranstaltungsthema", "rechnungsadresse", "nutzer_id", "id", "preis", "status"];

/**
 * @member {Boolean} archived
 * @default false
 */
RentalBooking.prototype['archived'] = false;

/**
 * @member {Date} von
 */
RentalBooking.prototype['von'] = undefined;

/**
 * @member {Date} bis
 */
RentalBooking.prototype['bis'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
RentalBooking.prototype['adresse'] = undefined;

/**
 * @member {String} veranstaltungsort
 */
RentalBooking.prototype['veranstaltungsort'] = undefined;

/**
 * @member {String} veranstaltungsthema
 */
RentalBooking.prototype['veranstaltungsthema'] = undefined;

/**
 * @member {String} rechnungsadresse
 */
RentalBooking.prototype['rechnungsadresse'] = undefined;

/**
 * @member {Array.<module:model/RentalItem>} items
 */
RentalBooking.prototype['items'] = undefined;

/**
 * @member {Array.<module:model/RentalPackage>} packages
 */
RentalBooking.prototype['packages'] = undefined;

/**
 * @member {String} nutzer_id
 */
RentalBooking.prototype['nutzer_id'] = undefined;

/**
 * @member {Number} id
 */
RentalBooking.prototype['id'] = undefined;

/**
 * @member {Number} preis
 */
RentalBooking.prototype['preis'] = undefined;

/**
 * @member {module:model/StatusEnum} status
 */
RentalBooking.prototype['status'] = undefined;

/**
 * @member {module:model/Nutzer} nutzer
 */
RentalBooking.prototype['nutzer'] = undefined;
var _default = exports.default = RentalBooking;